import queryString from 'query-string';

export function queryParam(name: string) {
  const searchString = window.location.search || window.location.hash.split('?')[1];
  const query = queryString.parse(searchString);
  return query[name];
}
